import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { NgClass } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wl-progressive-form-submit-button',
  templateUrl: './progressive-form-submit-button.component.html',
  styleUrls: ['./progressive-form-submit-button.component.scss'],
  standalone: true,
  imports: [
    CSCaptureDirective,
    NgClass,
    AutomationIdDirective,
    FaIconComponent,
    TranslatePipe,
  ],
})
export class ProgressiveFormSubmitButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() submitButtonAutomationId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() submitButtonText?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() submitButtonIcon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() submitButtonLoading?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isDisabled?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isEditingCurrentStep?: boolean;
  @Output() submitProgessiveForm: EventEmitter<void> = new EventEmitter();
  @Output() cancelEditingFormStep: EventEmitter<void> = new EventEmitter();
}
